(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

/* BTK asset-level mobile footer collapse 20260727 */
(() => {
  const run = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('footer details[data-testid="menu-details"]').forEach((details) => {
      if (details.dataset.btkUserToggled !== 'true') details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary && summary.dataset.btkFooterBound !== 'true') {
        summary.dataset.btkFooterBound = 'true';
        summary.addEventListener('click', () => {
          details.dataset.btkUserToggled = 'true';
        }, { passive: true });
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
})();
/* /BTK asset-level mobile footer collapse 20260727 */
